export default [
  { name: "absorptance", type: "string" },
  { name: "accessibilityPerformance", type: "string" },
  { name: "acousticPerformanceRw", type: "string" },
  { name: "acousticPerformanceRwCtr", type: "string" },
  { name: "airTightnessPerformance", type: "string" },
  { name: "assemblyCode", type: "string" },
  { name: "assemblyDescription", type: "string" },
  { name: "assetIdentifier", type: "string" },
  { name: "assetType", type: "string" },
  { name: "author", type: "string" },
  { name: "barCode", type: "string" },
  { name: "bimObjectName", type: "string" },
  { name: "bimspecGuid", type: "string" },
  { name: "bsBibleVersion", type: "string" },
  { name: "cavitySize", type: "string" },
  { name: "claddingType", type: "string" },
  { name: "coarseScaleFillColor", type: "string" },
  { name: "coarseScaleFillPattern", type: "string" },
  { name: "codePerformance", type: "string" },
  { name: "colour", type: "string" },
  { name: "connectionAccessories", type: "string" },
  { name: "connectionFasteners", type: "string" },
  { name: "constituents", type: "string" },
  { name: "constructionType", type: "string" },
  { name: "cost", type: "string" },
  { name: "createdBy", type: "string" },
  { name: "currentRevision", type: "string" },
  { name: "designOfFramingSystems", type: "string" },
  { name: "dimensionalConstraints", type: "string" },
  { name: "distributedBy", type: "string" },
  { name: "durationUnit", type: "string" },
  { name: "expectedLife", type: "string" },
  { name: "externalAirGap", type: "string" },
  { name: "externalBracketCentres", type: "string" },
  { name: "externalCladdingMaterial", type: "string" },
  { name: "externalCladdingRestraint", type: "string" },
  { name: "externalInsulation", type: "string" },
  { name: "externalSheathingBoard", type: "string" },
  { name: "features", type: "string" },
  { name: "finish", type: "string" },
  { name: "firePerformanceExternalFaceInsulation", type: "string" },
  { name: "firePerformanceExternalFaceIntegrity", type: "string" },
  { name: "firePerformanceExternalFaceLoadBearing", type: "string" },
  { name: "firePerformanceInsideFaceInsulation", type: "string" },
  { name: "firePerformanceInsideFaceIntegrity", type: "string" },
  { name: "firePerformanceInsideFaceLoadBearing", type: "string" },
  { name: "fireRating", type: "number" },
  { name: "framing", type: "string" },
  { name: "framingMembers", type: "string" },
  { name: "function", type: "string" },
  { name: "gapBetweenWallLinerAndFraming", type: "string" },
  { name: "grade", type: "string" },
  { name: "heatTransferCoefficient", type: "string" },
  { name: "ifcExportAs", type: "string" },
  { name: "ifcExportType", type: "string" },
  { name: "independentWallLiner", type: "string" },
  { name: "installationDate", type: "string" },
  { name: "insulationBetweenFraming", type: "string" },
  { name: "insulationBetweenStuds", type: "string" },
  { name: "insulationInternalManufacturer", type: "string" },
  { name: "insulationExternalManufacturer", type: "string" },
  { name: "insulationThickness", type: "number" },
  { name: "keynote", type: "string" },
  { name: "liningsFaceLayer", type: "string" },
  { name: "liningsFasteners", type: "string" },
  { name: "liningsInnerLayers", type: "string" },
  { name: "manufacturer", type: "string" },
  { name: "material", type: "string" },
  { name: "meansOfAdjustment", type: "string" },
  { name: "metwallTag", type: "string" },
  { name: "model", type: "string" },
  { name: "modelNumber", type: "string" },
  { name: "modelReference", type: "string" },
  { name: "movementJointConnections", type: "string" },
  { name: "nbsDescription", type: "string" },
  { name: "nbsNote", type: "string" },
  { name: "nbsOfficeMasterTag", type: "string" },
  { name: "nbsReference", type: "string" },
  { name: "nominalHeight", type: "string" },
  { name: "nominalLength", type: "string" },
  { name: "nominalWidth", type: "string" },
  { name: "plasterboardManufacturer", type: "string" },
  { name: "plasterboardType", type: "string" },
  { name: "plasterboardThickness", type: "number" },
  { name: "replacementCost", type: "string" },
  { name: "roughness", type: "string" },
  { name: "serialNumber", type: "string" },
  { name: "shape", type: "string" },
  { name: "size", type: "string" },
  { name: "structuralDesignSupervisionAndChecking", type: "string" },
  { name: "structuralMaterial", type: "string" },
  { name: "structure", type: "string" },
  { name: "sustainabilityPerformance", type: "string" },
  { name: "systemAccessories", type: "string" },
  { name: "systemManufacturer", type: "string" },
  { name: "systemType", type: "string" },
  { name: "tagNumber", type: "string" },
  { name: "thermalMass", type: "string" },
  { name: "thermalPerformance", type: "string" },
  { name: "thermalResistance", type: "string" },
  { name: "typeComments", type: "string" },
  { name: "typeImage", type: "string" },
  { name: "typeMark", type: "string" },
  { name: "typeOfAnchor", type: "string" },
  { name: "url", type: "string" },
  { name: "uValue", type: "number" },
  { name: "value", type: "string" },
  { name: "vapourControlLayer", type: "string" },
  { name: "warrantyDescription", type: "string" },
  { name: "warrantyDurationLabour", type: "string" },
  { name: "warrantyDurationParts", type: "string" },
  { name: "warrantyDurationUnit", type: "string" },
  { name: "warrantyGuarantorLabour", type: "string" },
  { name: "warrantyGuarantorParts", type: "string" },
  { name: "warrantyStartDate", type: "string" },
  { name: "wallWidth", type: "number" },
  { name: "width", type: "string" },
  { name: "wrappingAtEnds", type: "string" },
  { name: "wrappingAtInserts", type: "string" }
];
